__webpack_require__.p = "https://cdnc.lms360.vn/2026-01-12/afad6b2c-1872-45e8-9d44-b27d0b1d4129/";